import React, {useState} from 'react';
import {ReactComponent as AppSwitcherIcon} from 'images/app-switcher/AppSwitcher.svg';
import {ReactComponent as CogIcon} from 'images/app-switcher/cog-transparent.svg';
import IconButton from '@material-ui/core/IconButton';
import './PrimaryNav.scss';
import User from 'records/User';
import {AppSwitcher} from '@components/primary-nav/AppSwitcher';
import {Link} from 'react-router';

interface PrimaryNavProps {
  user: User;
}

/**
 * Left hand side nav
 */
export const PrimaryNav: React.FC<PrimaryNavProps> = ({user, children}) => {
  const [switcherOpen, setSwitcherOpen] = useState(false);
  const [switcherAnchor, setSwitcherAnchor] = useState<HTMLButtonElement | null>(null);

  // Hide the side nav if the user is using i360 embed mode, so that there aren't
  // duplicate navbars from i360 and c360
  const showNav = user.solutionList && user.solutionList.length > 1 && !user.i360Embed;

  return (
    <div className="app-wrapper">
      {showNav && (
        <div className="primary-nav">
          <div className="top-content">
            <IconButton
              ref={r => setSwitcherAnchor(r)}
              onClick={() => setSwitcherOpen(!switcherOpen)}>
              <AppSwitcherIcon className="app-switcher-icon icon" />
            </IconButton>
            <AppSwitcher open={switcherOpen} user={user} anchorEl={switcherAnchor} />
          </div>
          <div className="center-content"></div>
          <div className="bottom-content">
            <Link to="/admin">
              <IconButton>
                <CogIcon className="cog icon" />
              </IconButton>
            </Link>
          </div>
        </div>
      )}
      <div id="app-child-content" className="child-content">
        {children}
      </div>
    </div>
  );
};
